var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTypeTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#51ACE0;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.9,0.9h-10c-1.1,0-2,0.9-2,2v10c0,1.1,0.9,2,2,2h10c1.1,0,2-0.9,2-2v-10C14.9,1.8,14,0.9,12.9,0.9z M11.7,6 l-4,5c0,0,0,0,0,0c0,0,0,0,0,0.1c-0.1,0.1-0.1,0.1-0.2,0.1c0,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.3,0.1-0.4,0.1c0,0,0,0,0,0s0,0,0,0 c-0.1,0-0.2,0-0.4-0.1c0,0-0.1,0-0.1-0.1c-0.1,0-0.1-0.1-0.2-0.1c0,0,0,0,0,0c0,0,0,0,0,0l-2-2c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0 l1.2,1.2l3.3-4.1c0.3-0.4,1-0.5,1.4-0.2C12,4.9,12,5.6,11.7,6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeTask);
export default __webpack_public_path__ + "static/media/type_task.d93894dd735cfad4a280fcca3e0bbbeb.svg";
export { ForwardRef as ReactComponent };